/**
 * Case Map Set API service
 *
 * Provides functions for managing case-level map sets for visualisation.
 */

import { apiClient } from './api'
import type {
  CaseMapSet,
  SetMapSetRequest,
  ModifyMapSetRequest,
  AddFromFilterRequest,
} from '../types/case-container'

// =============================================================================
// MAP SET API
// =============================================================================

/**
 * Get current map set for a case
 */
export async function getMapSet(caseId: string): Promise<CaseMapSet> {
  return apiClient.get<CaseMapSet>(`/cases/${caseId}/map-set`)
}

/**
 * Replace entire map set
 */
export async function setMapSet(caseId: string, request: SetMapSetRequest): Promise<CaseMapSet> {
  return apiClient.put<CaseMapSet>(`/cases/${caseId}/map-set`, request)
}

/**
 * Add endpoint IDs to map set
 */
export async function addToMapSet(
  caseId: string,
  request: ModifyMapSetRequest
): Promise<CaseMapSet> {
  return apiClient.patch<CaseMapSet>(`/cases/${caseId}/map-set/add`, request)
}

/**
 * Remove endpoint IDs from map set
 */
export async function removeFromMapSet(
  caseId: string,
  request: ModifyMapSetRequest
): Promise<CaseMapSet> {
  return apiClient.patch<CaseMapSet>(`/cases/${caseId}/map-set/remove`, request)
}

/**
 * Clear all items from map set
 */
export async function clearMapSet(caseId: string): Promise<void> {
  await apiClient.delete(`/cases/${caseId}/map-set`)
}

/**
 * Add all items matching filter to map set
 */
export async function addFromFilter(
  caseId: string,
  request: AddFromFilterRequest
): Promise<CaseMapSet> {
  return apiClient.post<CaseMapSet>(`/cases/${caseId}/map-set/from-filter`, request)
}
